// extracted by mini-css-extract-plugin
export var Section = "Slogan-module--Section--OrZsp";
export var LangHY = "Slogan-module--LangHY--JGePa";
export var Text = "Slogan-module--Text--SQmTG";
export var Inner = "Slogan-module--Inner--9K95s";
export var BorderTop = "Slogan-module--BorderTop--Whnm7";
export var BorderRight = "Slogan-module--BorderRight--CFVf2";
export var BorderBottom = "Slogan-module--BorderBottom--ZzToD";
export var BorderLeft = "Slogan-module--BorderLeft--LnplZ";
export var Image = "Slogan-module--Image--rJ6Zl";
export var arrowLeft = "Slogan-module--arrowLeft--JGdmJ";
export var arrowRight = "Slogan-module--arrowRight--oifr9";